import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import { DetailLineItemProps } from './interface'

const DetailLineItem: React.FC<DetailLineItemProps> = ({ label, value }) => {
  return (
    <Flex gap={1} fontSize="14px">
      <Box
        width="40%"
        background="rgb(250, 250, 250)"
        borderRadius="4px"
        padding="8px"
      >
        {label}
      </Box>
      <Box
        background="rgb(250, 250, 250)"
        borderRadius="4px"
        padding="8px"
        flex={1}
      >
        {value}
      </Box>
    </Flex>
  )
}

export default DetailLineItem
